import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bdo-circle-icon-text-small',
    templateUrl: './circle-icon-text-small.component.html',
    styleUrls: ['./circle-icon-text-small.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CircleIconTextSmallComponent {
  @Input() label: string;
  @Input() iconStyle: 'plus' | 'minus' = 'plus';

  @Output() clickEvent: EventEmitter<boolean> = new EventEmitter();

  onClickButton(): void {
    this.clickEvent.emit();
  }
}
